import * as React from 'react';
import { Button } from '@cian/ui-kit';
import classNames from 'classnames';

import { ICity } from '../../store/geo';
import { DEFAULT_CITY_REGIONS_IDS, IGeoSuggestItem } from '../../utils/geo';
import { LocationSwitcher } from '../cian/location_switcher/location_switcher';
import { CommutePopupContainer } from '../commute_popup/container';
import { IFiltersDispatchProps, IFiltersStoreProps } from './container';
import { ExtraFiltersContainer } from './extra_filters/container';
import { GeoTextField } from './geo_textfield';
import { getPopupButtonLabel } from './helpers';
import { ObjectType } from './components/ObjectType';
import { VillageClass } from './components/VillageClass';
import { FinishDate } from './components/FinishDate';
import { SavedFiltersContainer } from './saved_filters/container';
import { Price } from './components/Price';
import * as styles from './index.css';

export type IProps = IFiltersStoreProps & IFiltersDispatchProps;

interface IState {
  geoTextValue: string;
  isGeoPopupOpened: boolean;
}

export class Filters extends React.Component<IProps, IState> {
  public state = {
    geoTextValue: '',
    isGeoPopupOpened: false,
  };

  public async componentDidMount() {
    this.props.changeQueryString(this.props.filters);
    this.props.fetchRegions();
  }

  public render() {
    const {
      commutePopupOpened,
      geo,
      filters,
      roadData,
      roads,
      stationData,
      stations,
      fetchRegionsCities,
      fetchVillageSuggestions,
      filterRoads,
      filterStations,
      changeNewObjectTypeFilter,
      changeVillageClassFilter,
      changeFinishDateFilter,
      changePriceRangeFilter,
      clearVillageSuggestions,
      fetchBuilderSuggestions,
      clearBuilderSuggestions,
      refreshRegions,
      selectRoad,
      selectStation,
      selectBuilder,
      showCommutePopup,
    } = this.props;
    const { regionHasRoads } = roads;
    const { regionHasStations } = stations;
    const { isGeoPopupOpened, geoTextValue } = this.state;

    const isCommuteButtonEnabled = !!Object.keys(roadData || stationData || {}).length;

    return (
      <div className={styles['container']}>
        <div className={styles['container-inner']}>
          <div className={styles['controls']}>
            <div className={styles['controls-group']}>
              <div className={styles['control']}>
                <ObjectType value={filters.newobjectType} onChange={changeNewObjectTypeFilter} />
              </div>
              <div className={styles['control']}>
                <VillageClass value={filters.villageClass} onChange={changeVillageClassFilter} />
              </div>
              <div className={styles['control']}>
                <FinishDate value={filters.finishDate} onChange={changeFinishDateFilter} />
              </div>
              <div className={styles['control']}>
                <Price
                  value={{
                    min: filters.priceFrom,
                    max: filters.priceTo,
                  }}
                  onChange={changePriceRangeFilter}
                />
              </div>
              <div className={styles['control']}>
                <ExtraFiltersContainer />
              </div>
            </div>
            <div className={styles['controls-group']}>
              <div className={classNames(styles['control'], styles['geo-search'])}>
                <GeoTextField
                  onItemSelect={this.handleGeoTextFieldSelect}
                  onRoadSelect={selectRoad}
                  onStationSelect={selectStation}
                  onBuilderSelect={selectBuilder}
                  onChange={this.handleGeoTextChange}
                  textValue={geoTextValue}
                  roads={roads}
                  stations={stations}
                  geo={geo}
                  roadButton={{
                    label: getPopupButtonLabel(regionHasRoads, regionHasStations),
                    available: isCommuteButtonEnabled,
                  }}
                  filterRoads={filterRoads}
                  filterStations={filterStations}
                  fetchVillageSuggestions={fetchVillageSuggestions}
                  clearVillageSuggestions={clearVillageSuggestions}
                  fetchBuilderSuggestions={fetchBuilderSuggestions}
                  clearBuilderSuggestions={clearBuilderSuggestions}
                  showGeoPopup={this.handleGeopopupOpen}
                  showCommutePopup={showCommutePopup}
                />
              </div>
              <div className={styles['control']}>
                <Button size="XS" onClick={this.loadData} aria-label="Найти">
                  Найти
                </Button>
              </div>
            </div>
          </div>
          <SavedFiltersContainer />
          <LocationSwitcher
            isPopupOpen={isGeoPopupOpened}
            geo={geo}
            onLocationChange={this.handleLocationChange}
            onRegionSelect={refreshRegions}
            onCloseButtonClick={this.handleLocationSwitcherClose}
            fetchRegionsCities={fetchRegionsCities}
          />
          {commutePopupOpened && <CommutePopupContainer />}
        </div>
      </div>
    );
  }

  private handleGeopopupOpen = () => {
    const {
      geo: { selectedRegion },
      refreshRegions,
    } = this.props;
    if (selectedRegion) {
      refreshRegions(selectedRegion, true);
    }
    this.setState({
      isGeoPopupOpened: true,
    });
  };

  private handleLocationSwitcherClose = () => this.setState({ isGeoPopupOpened: false });

  private handleLocationChange = (region: ICity, isDefaultCity = false) => {
    const { changeRegion, refreshPage } = this.props;
    this.setState({
      isGeoPopupOpened: false,
    });

    changeRegion(isDefaultCity ? { ...region, id: DEFAULT_CITY_REGIONS_IDS[region.id] || region.id } : region);
    refreshPage(1, true);
  };

  private handleGeoTextChange = (text: string) => this.setState({ geoTextValue: text });

  private loadData = () => {
    const { refreshPage, filters, clearVillageList } = this.props;
    const { geoTextValue } = this.state;
    const trimmedGeoTextValue = geoTextValue.trim();

    this.setState({
      geoTextValue: trimmedGeoTextValue,
    });

    if (trimmedGeoTextValue !== '') {
      clearVillageList({
        ...filters,
      });

      return;
    }

    refreshPage(filters.p || 1);
  };

  private handleGeoTextFieldSelect = (suggest: IGeoSuggestItem) => {
    this.props.fetchCachedGeocode(suggest.displayName);
  };
}
